import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function LiveOverview() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => {
      navigate("/live/dashboard");
    }, 3500);

    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>FentaSafe Monitoring Environment</h1>

        <div style={styles.statusRow}>
          <span style={styles.dot}></span>
          Secure Environment Active
        </div>

        <p style={styles.subtitle}>
          Facility authentication confirmed.
        </p>

        <div style={styles.loader}></div>

        <p style={styles.steps}>
          Connecting sensor streams...<br />
          Loading AI risk monitoring services...<br />
          Preparing operational dashboard...
        </p>

        <p style={styles.redirect}>
          Launching operational dashboard...
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#020617",
    color: "white",
    fontFamily: "system-ui"
  },

  card: {
    background: "#0f172a",
    border: "1px solid #1e293b",
    borderRadius: 14,
    padding: "40px",
    width: 420,
    textAlign: "center",
    boxShadow: "0 20px 40px rgba(0,0,0,0.5)"
  },

  title: {
    fontSize: "1.8rem",
    marginBottom: 12
  },

  subtitle: {
    opacity: 0.7,
    marginBottom: 20
  },

  statusRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    color: "#22c55e",
    fontSize: "0.9rem",
    marginBottom: 8
  },

  dot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: "#22c55e",
    boxShadow: "0 0 10px #22c55e"
  },

  loader: {
    width: 40,
    height: 40,
    border: "4px solid #1e293b",
    borderTop: "4px solid #22c55e",
    borderRadius: "50%",
    margin: "20px auto",
    animation: "spin 1s linear infinite"
  },

  steps: {
    fontSize: "0.85rem",
    opacity: 0.7,
    lineHeight: 1.6
  },

  redirect: {
    marginTop: 16,
    fontSize: "0.8rem",
    opacity: 0.6
  }
};